import { identifyPosthogFromAuth } from "@/lib/analytics";
import { useAuthStore } from "@/stores/auth";
import { geniFetch } from "@/api/geniBackend";

export const getCardGeniusAccountProfile = async () => {
  const authStore = useAuthStore();

  const profile = await geniFetch<{
    id: string;
    userId: string;
    geniBalance: number;
    email?: string;
    phone?: string;
    phoneVerifiedAt?: string | null;
    emailVerifiedAt?: string | null;
    theme?: "light" | "dark";
    marketplaceToken?: string;
    metadata?: Record<string, unknown>;
    hasPassword?: boolean | null;
    registrationProvider?: string | null;
    onboardingCompletedAt?: string | null;
  }>("/account/profile");
  authStore.setCardGeniusAccountProfile({
    profile_id: profile.id,
    userId: profile.userId,
    email: profile.email ?? "",
    phone: profile.phone ?? "",
    geni_balance: profile.geniBalance ?? 0,
    field_5: "cardGeniusAccount",
    hasPassword: profile.hasPassword ?? undefined,
    registrationProvider: profile.registrationProvider ?? undefined,
    onboardingCompletedAt: profile.onboardingCompletedAt ?? null,
    field_19: {
      theme: profile.theme,
      wildberries: profile.marketplaceToken ?? "",
      ...(profile.metadata ?? {}),
    },
  });
  identifyPosthogFromAuth();
};
